import {Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import {RequestService} from '../../../handlers/request/request.service';
import {home} from '../../api/cms/home.api';
import {globalEnv} from '../../connection/global/global.env';
@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private req: RequestService) {}

  getHome(data) {
    return null;
  }

  getStructureHome( data ):Observable<any>{
    return this.req.post(`${globalEnv.gateway}${home.structure}`, data);
  }

  getComponentHome( api, data ):Observable<any>{
    return this.req.post(`${globalEnv.gateway}${api}`, data)
  }
}
